import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Add from '@material-ui/icons/Add';
import strings from 'strings';
import { FPActionButton, When } from 'UI/components/atoms';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';

import { SendoutNote } from '../SendoutNote';
import { SendoutNoteForm } from '../SendoutNoteForm';

export const SendoutNotesTabContent = ({ canManageSendout, notes, refreshData, sendoutId }) => {
  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const notesList = notes ?? [];
  const isEmpty = notesList.length === 0;

  const handleAddNote = () => {
    setIsAddFormVisible(true);
  };

  const handleCancelAddNote = () => {
    setIsAddFormVisible(false);
  };

  const handleFinishSave = async () => {
    setIsAddFormVisible(false);
    refreshData && (await refreshData());
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <When condition={canManageSendout}>
          <FPActionButton
            disabled={isAddFormVisible}
            icon={Add}
            iconPosition="left"
            onClick={handleAddNote}
            text={strings.sendoutsV2.drawers.tabs.notes.add}
          />
        </When>
      </Box>

      <When condition={isAddFormVisible}>
        <SendoutNoteForm
          onCancel={handleCancelAddNote}
          onFinishSave={handleFinishSave}
          sendoutId={sendoutId}
          title={strings.sendoutsV2.drawers.tabs.notes.add}
        />
      </When>

      <When condition={!isEmpty}>
        {notesList.map(note => (
          <SendoutNote
            key={note.id}
            note={note}
            onFinishSave={handleFinishSave}
            sendoutId={sendoutId}
          />
        ))}
      </When>

      <When condition={!isAddFormVisible && isEmpty}>
        <EmptyPlaceholder subtitle={strings.sendoutsV2.drawers.tabs.notes.emptyState.subtitle} />
      </When>
    </>
  );
};
